import { Transition } from 'framer-motion';

// Uma única linguagem de movimento para o app inteiro: saída rápida e suave (ease-out
// "expo"), sem quicar. Tudo que anima deve puxar daqui para o produto parecer um só.
export const EASE_OUT: [number, number, number, number] = [0.22, 1, 0.36, 1];

export const DURATION = {
  fast: 0.2,
  base: 0.45,
  slow: 0.9,
};

export const TRANSITION: Transition = { duration: DURATION.base, ease: EASE_OUT };
export const GROW: Transition = { duration: DURATION.slow, ease: EASE_OUT };
export const SPRING: Transition = { type: 'spring', stiffness: 380, damping: 32 };

// Atraso entre itens irmãos (colunas, barras, tiles) — curto o bastante para não parecer lento.
export const STAGGER = 0.06;
